import styled from 'styled-components'

export const WideButton = styled.button`
  align-items: center;
  background-color: var(--sn-stylekit-background-color);
  border-radius: 8px;
  border: 1px solid var(--sn-stylekit-border-color);
  box-sizing: border-box;
  color: var(--sn-stylekit-paragraph-text-color);
  cursor: pointer;
  display: flex;
  height: 36px;
  justify-content: center;
  width: 100%;
`
